<template>
    <div :class="[
        'course__show_attachments',
        mainBoxActive ? 'course__show_attachments--opened' : ''
    ]">
        <div class="course__show_attachments_header">
            <div class="columns is-vcentered is-variable is-2">
                <div class="column is-narrow">
                    <component-title
                        :size="'small'"
                        :raw="true"
                    >Attachments
                    </component-title>
                </div>
                <div class="column">
                    <div class="course__show_attachments_header_size">({{ files.length }} files - {{ `${(filesTotalSize / (1024*1024)).toFixed(2) + 'MB)'}` }}</div>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :name="'course-show-attachments-expand'"
                        :icon="true"
                        :icon-name="mainBoxActive ? 'chevron-up' : 'chevron-down'"
                        :icon-raw="true"
                        :theme="''"
                        @click="switchMainBox"
                    ></component-button>
                </div>
            </div>
        </div>
        <template v-if="mainBoxActive">
            <div class="course__show_attachments_main">
                <div class="course__show_attachments_main_files">
                    <template v-for="(file, index) in files">
                        <div
                            :key="index"
                            class="course__show_attachments_main_files_item"
                        >
                            <div class="columns is-vcentered">
                                <div class="column">
                                    <div class="course__show_attachments_main_files_item_name">
                                        {{ file.name }}
                                    </div>
                                </div>
                                <div class="column is-narrow">
                                    <div class="course__show_attachments_main_files_item_size">{{ `(${(file.size / (1024*1024)).toFixed(2) + 'MB)'}` }}</div>
                                </div>
                                <div class="column is-narrow">
                                    <div class="course__show_attachments_main_files_item_actions">
                                        <component-button
                                            :disabled="!allowToDownload"
                                            :class="'course__show_attachments_main_files_item_actions_preview'"
                                            :name="'course-show-attachments-main-files-item-preview'"
                                            :to-external="file.url"
                                            :target="true"
                                            :theme="'default'"
                                            :icon="true"
                                            :icon-name="'download'"
                                            :hint="!allowToDownload ? 'Enrol to download file' : ''"
                                        >
                                        </component-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'

export default {
  name: 'course-show-attachments',
  components: { ComponentButton, ComponentTitle },
  data () {
    return {
      mainBoxActive: false,
      user: new User()
    }
  },
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    routeIsCourseView () {
      return this.$route.name === 'ebs-course-show'
    },
    routeIsCourseVersionView () {
      return this.$route.name === 'ebs-course-version-show'
    },
    filesTotalSize () {
      const files = this.files

      return files.map(obj => obj.size).reduce((a, b) => Number(a) + Number(b), 0)
    },
    isUserEnrolled () {
      return this.$store.getters.getEbsEnrolmentIsUserEnrolled
    },
    allowToDownload () {
      return (
        (
          this.routeIsCourseVersionView &&
      this.isUserEnrolled
        ) ||
      (
        this.routeIsCourseView &&
      (
        this.user.isCourseCreator() ||
      this.user.isLearningExperienceAdministrator()
      )
      )
      )
    }
  },
  methods: {
    switchMainBox () {
      this.mainBoxActive = !this.mainBoxActive
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseshowattachments";
</style>
